<template>
  <ContentSection>
    <Container tag="div">
      <h2 v-if="data.heading" class="mb-9 font-semibold typo-h3" v-html="data.heading" />
      <AnimatedContainer
        v-if="data.facts.length"
        class="
          flex flex-col gap-x-default gap-y-default
          sm:grid sm:grid-cols-[repeat(auto-fill,_minmax(24.25rem,_1fr))]
        "
      >
        <div
          v-for="fact in data.facts"
          :key="fact.id"
          class="relative flex flex-col slide-up"
          :class="{ group: fact.link }"
        >
          <!-- IMG -->
          <div
            v-if="hasImages"
            class="mb-8 aspect-[4/3] w-full overflow-hidden"
            :class="{ 'bg-gradient-03': !fact.image }"
          >
            <AppImage
              class="
                size-full object-cover transition-transform duration-500 ease-in-out
                group-hover-focus:scale-110
              "
              :src="fact.image"
            />
          </div>
          <!-- /IMG -->
          <!-- CONTENT -->
          <div
            class="
              flex grow flex-col transition duration-100 ease-in
              group-hover-focus:scale-[1.0025] group-hover-focus:text-secondary-900
              group-hover-focus:duration-200 group-hover-focus:ease-out
            "
          >
            <h3 class="mb-2 font-semibold typo-h6">
              {{ fact.heading }}
            </h3>
            <div class="max-w-text typo-body" v-html="fact.text" />
            <div class="mt-auto">
              <AppButton
                v-if="fact.link && fact.link_text"
                class="mt-4"
                :to="fact.link"
                variant="secondary"
              >
                {{ fact.link_text }}
              </AppButton>
            </div>
          </div>
          <!-- /CONTENT -->
          <NuxtLink
            v-if="fact.link"
            :to="fact.link"
            class="after:absolute after:inset-0"
          />
        </div>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsFactsFragment } from '#gql'

const props = defineProps<{
  data: Enforce<MainComponentsFactsFragment>
}>()

const hasImages = computed(() => props.data.facts.some(fact => fact?.image))
</script>
